import API from "../../Data/Domain/API";
import URL from "../../Data/Domain/URL";
import Storage from "../../Data/Domain/Storage";

export async function getYearOfDisplayByUser(id) {
  const internal_id = id || new Storage("id").getItem();
  return await new API(URL.buildUrl(`users/${internal_id}/years`)).get();
}
